import Dialog from 'components/Dialog.jsx';
import Group from 'entities/Group';
import GroupEditPanel from './GroupEditPanel.jsx';
import GroupMemberList from './GroupMemberList.jsx';
import React from 'react';
import TabPanel from 'components/TabPanel.jsx';
import Tabs from 'components/Tabs.jsx';

class GroupSettingsModal extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group),
    onCodeChange: React.PropTypes.func.isRequired,
    userIsTeacher: React.PropTypes.bool.isRequired,
  };

  renderGroupInformationPanel = () => {
    return (
      <GroupEditPanel {...this.props} />
    );
  };

  renderGroupOwnerManagerPanel = () => {
    return (
      <GroupMemberList
        {...this.props}
        className="GroupMemberList"
        group={this.props.group}
      />
    );
  };

  render() {
    return (
      <Dialog
        eventScreenName="GroupSettingsModal"
        {...this.props}
        className="GroupSettingsModal"
        title="Class settings"
        size="small">
        <Tabs tabAlign="center">
          <TabPanel title={<span>Information</span>}>
            {this.renderGroupInformationPanel()}
          </TabPanel>
          <TabPanel title={<span>Owners</span>}>
            {this.renderGroupOwnerManagerPanel()}
          </TabPanel>
        </Tabs>
      </Dialog>
    );
  }
}

export default GroupSettingsModal;



// WEBPACK FOOTER //
// ./src/groups/components/GroupSettingsModal.jsx